import {
  ApiResult,
  FetchApiCallback,
  useApiGet,
  useApiPost,
  useApiPatch
} from '../../common/api/Api.hooks';
import { useIdSearchableFetch } from '../../common/entityId.hooks';
import { PaginatedList } from '../../common/PaginatedList.interface';
import { Supplier } from '../supplier/Supplier.interface';
import { WorkflowEntity } from '../workflow/Workflow.interface';
import { Scar } from './Scar.interface';

export function useGetScarList(): [
  ApiResult<PaginatedList<Scar>>,
  FetchApiCallback
] {
  const { data, isLoading, error, get } = useApiGet<PaginatedList<Scar>>(
    'scar'
  );
  const getScarList = useIdSearchableFetch(get, WorkflowEntity.Scar);
  return [{ data, isLoading, error }, getScarList];
}

export function useFindScarsBySupplier(
  supplierId: number
): [ApiResult<PaginatedList<Scar>>, FetchApiCallback] {
  const { data, isLoading, error, get } = useApiGet<PaginatedList<Scar>>(
    'suppliers/' + supplierId + '/scars'
  );
  const findScars = useIdSearchableFetch(get, WorkflowEntity.Scar);
  return [{ data, isLoading, error }, findScars];
}

export function useGetSupplierList(): [
  ApiResult<PaginatedList<Supplier>>,
  FetchApiCallback
] {
  const { data, isLoading, error, get } = useApiGet<PaginatedList<Supplier>>(
    'suppliers'
  );
  return [{ data, isLoading, error }, get];
}

export function useCreateScar(): [ApiResult<Scar>, FetchApiCallback] {
  const { data, isLoading, error, post } = useApiPost<Scar>('scar/');
  return [{ data, isLoading, error }, post];
}

export function useUpdateScar(id: number) {
  const { data, isLoading, error, patch } = useApiPatch<Supplier>(`scar/${id}`);
  return {
    updatedScar: data,
    isUpdating: isLoading,
    updateError: error,
    updateScar: patch
  };
}

export function useFindScarByTask(taskId: number) {
  const { data, isLoading, error, get } = useApiGet<Scar>(
    'scar/task/' + taskId
  );
  return { data, isLoading, error, get };
}
